module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: ""
  }, [_c('div', {
    staticClass: "SiftPanel",
    staticStyle: {
      "border": "0px solid #bbbbbb",
      "height": "30px"
    }
  }, [_c('div', {
    staticClass: "Capt DIVNoSelect",
    staticStyle: {
      "flex": "0 0 auto",
      "border": "0",
      "width": "160px",
      "margin-top": "-1px",
      "margin-left": "20px",
      "color": "#aaaaaa"
    }
  }, [_vm._v("客户名称")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.custName),
      expression: "custName"
    }],
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "type": "text",
      "maxlength": "30",
      "disabled": "true"
    },
    domProps: {
      "value": (_vm.custName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.custName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "SiftPanel",
    staticStyle: {
      "border": "0px solid #bbbbbb",
      "height": "30px",
      "margin-top": "5px"
    }
  }, [_c('div', {
    staticClass: "Capt DIVNoSelect",
    staticStyle: {
      "flex": "0 0 auto",
      "border": "0",
      "width": "160px",
      "margin-top": "-1px",
      "margin-left": "20px",
      "color": "#aaaaaa"
    }
  }, [_vm._v("有效期至")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.preValidateText),
      expression: "preValidateText"
    }],
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "type": "text",
      "maxlength": "30",
      "disabled": "true"
    },
    domProps: {
      "value": (_vm.preValidateText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.preValidateText = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "SiftPanel",
    staticStyle: {
      "border": "0px solid #bbbbbb",
      "height": "30px",
      "margin-top": "5px"
    }
  }, [_c('div', {
    staticClass: "Capt DIVNoSelect",
    staticStyle: {
      "flex": "0 0 auto",
      "border": "0",
      "width": "160px",
      "margin-top": "-1px",
      "margin-left": "20px",
      "color": "#aaaaaa"
    }
  }, [_vm._v("设备状态")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.preStsText),
      expression: "preStsText"
    }],
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "type": "text",
      "maxlength": "30",
      "disabled": "true"
    },
    domProps: {
      "value": (_vm.preStsText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.preStsText = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "SiftPanel",
    staticStyle: {
      "border": "0px solid #bbbbbb",
      "height": "40px"
    }
  }, [_c('div', {
    staticClass: "Capt DIVNoSelect",
    staticStyle: {
      "flex": "0 0 auto",
      "border": "0",
      "width": "160px",
      "color": "#ff0000",
      "margin-top": "-1px",
      "margin-left": "20px"
    }
  }, [_vm._v("硬件编码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.devHdcode),
      expression: "devHdcode"
    }],
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "type": "text",
      "maxlength": "30"
    },
    domProps: {
      "value": (_vm.devHdcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.devHdcode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "NButton DIVNoSelect",
    staticStyle: {
      "width": "32px",
      "height": "32px",
      "background": "url(../static/images/op_fin.png)",
      "margin-top": "-1px",
      "margin-left": "10px"
    },
    on: {
      "click": _vm.onDevInfoClick
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "SiftPanel",
    staticStyle: {
      "border": "0px solid #bbbbbb",
      "height": "40px"
    }
  }, [_c('div', {
    staticClass: "Capt DIVNoSelect",
    staticStyle: {
      "flex": "0 0 auto",
      "border": "0",
      "width": "160px",
      "margin-top": "-1px",
      "margin-left": "20px",
      "color": "#ff0000"
    }
  }, [_vm._v("销售")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dfPayChannel),
      expression: "dfPayChannel"
    }],
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "type": "text",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.dfPayChannel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dfPayChannel = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "SiftPanel",
    staticStyle: {
      "border": "0px solid #bbbbbb",
      "height": "40px"
    }
  }, [_c('div', {
    staticClass: "Capt DIVNoSelect",
    staticStyle: {
      "flex": "0 0 auto",
      "border": "0",
      "width": "160px",
      "margin-top": "-1px",
      "margin-left": "20px",
      "color": "#ff0000"
    }
  }, [_vm._v("订单号")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dfCertificate),
      expression: "dfCertificate"
    }],
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "type": "text",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.dfCertificate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dfCertificate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "SiftPanel",
    staticStyle: {
      "border": "0px solid #bbbbbb",
      "height": "40px"
    }
  }, [_c('div', {
    staticClass: "Capt DIVNoSelect",
    staticStyle: {
      "flex": "0 0 auto",
      "border": "0",
      "width": "160px",
      "margin-top": "-1px",
      "margin-left": "20px",
      "color": "#ff0000"
    }
  }, [_vm._v("购买时长")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dfBuyMonths),
      expression: "dfBuyMonths"
    }],
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "type": "text",
      "maxlength": "4"
    },
    domProps: {
      "value": (_vm.dfBuyMonths)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dfBuyMonths = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "SiftPanel",
    staticStyle: {
      "border": "0px solid #bbbbbb",
      "height": "40px"
    }
  }, [_c('div', {
    staticClass: "Capt DIVNoSelect",
    staticStyle: {
      "flex": "0 0 auto",
      "border": "0",
      "width": "160px",
      "margin-top": "-1px",
      "margin-left": "20px"
    }
  }, [_vm._v("金额")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dfPayAmount),
      expression: "dfPayAmount"
    }],
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "type": "text",
      "maxlength": "8"
    },
    domProps: {
      "value": (_vm.dfPayAmount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dfPayAmount = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "SiftPanel",
    staticStyle: {
      "border": "0px solid #bbbbbb",
      "height": "40px"
    }
  }, [_c('div', {
    staticClass: "Capt DIVNoSelect",
    staticStyle: {
      "flex": "0 0 auto",
      "border": "0",
      "width": "160px",
      "margin-top": "-1px",
      "margin-left": "20px"
    }
  }, [_vm._v("币种")]), _vm._v(" "), _c('check', {
    staticStyle: {
      "height": "30px",
      "margin-right": "10px",
      "margin-left": "0px"
    },
    attrs: {
      "size": 18,
      "grpName": 'GrpCurrency',
      "val": 156,
      "capt": 'RMB',
      "checked": false
    }
  }), _vm._v(" "), _c('check', {
    staticStyle: {
      "height": "30px",
      "margin-right": "20px"
    },
    attrs: {
      "size": 18,
      "grpName": 'GrpCurrency',
      "val": 840,
      "capt": 'USD',
      "checked": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "SiftPanel",
    staticStyle: {
      "border": "0px solid #bbbbbb",
      "height": "40px"
    }
  }, [_c('div', {
    staticClass: "Capt DIVNoSelect",
    staticStyle: {
      "flex": "0 0 auto",
      "border": "0",
      "width": "160px",
      "margin-top": "-1px",
      "margin-left": "20px"
    }
  }, [_vm._v("付款日期")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dfPayDate),
      expression: "dfPayDate"
    }],
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "type": "text",
      "maxlength": "8",
      "placeholder": "yyyymmdd"
    },
    domProps: {
      "value": (_vm.dfPayDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dfPayDate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "width": "100%",
      "height": "40px",
      "border": "0px solid red",
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "NButton DIVNoSelect",
    staticStyle: {
      "padding-left": "10px",
      "padding-right": "10px",
      "margin-top": "16px",
      "margin-left": "70px"
    },
    on: {
      "click": _vm.onCancelClick
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('div', {
    staticClass: "NButton DIVNoSelect",
    staticStyle: {
      "padding-left": "10px",
      "padding-right": "10px",
      "margin-top": "16px",
      "margin-right": "70px",
      "float": "right"
    },
    on: {
      "click": _vm.onOKClick
    }
  }, [_vm._v("确定")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "SiftPanel",
    staticStyle: {
      "border": "0px solid #bbbbbb",
      "height": "30px",
      "margin-top": "5px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "1px",
      "background": "#bbbbbb"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e4ff5176","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/aiphoto/feeNew.vue
// module id = 807
// module chunks = 1